import { CommonProp } from '@acin/ui-core';
import React from 'react';
import { useMapControls } from '../../MapControlsProvider';
import * as SC from './ControlDetails.styled';

export interface ControlInstance {
  id: string;
  controlId: string;
  name: string;
  descriptionReview?: string | null;
  descriptionIdentify?: string | null;
  descriptionAction?: string | null;
  objective?: string | null;
  type?: string | null;
  automation?: string | null;
}

export interface ControlDetailsProps extends CommonProp {}

export const ControlDetails: React.FC<ControlDetailsProps> = () => {
  const { activeObligationRuleControlMapping } = useMapControls();
  const controlInstance = activeObligationRuleControlMapping?.control?.latestInstance;

  if (!controlInstance) {
    return (
      <SC.PlaceholderContainer>
        <SC.PlaceholderText>Select a controlInstance to view details</SC.PlaceholderText>
      </SC.PlaceholderContainer>
    );
  }

  return (
    <SC.DetailsContainer>
      {(controlInstance.descriptionReview ||
        controlInstance.descriptionIdentify ||
        controlInstance.descriptionAction) && (
        <>
          <SC.SectionHeading>DESCRIPTION</SC.SectionHeading>
          {controlInstance.descriptionReview && (
            <SC.DescriptionParagraph>{controlInstance.descriptionReview}</SC.DescriptionParagraph>
          )}
          {controlInstance.descriptionIdentify && (
            <SC.DescriptionParagraph>{controlInstance.descriptionIdentify}</SC.DescriptionParagraph>
          )}
          {controlInstance.descriptionAction && (
            <SC.DescriptionParagraph>{controlInstance.descriptionAction}</SC.DescriptionParagraph>
          )}
        </>
      )}

      {controlInstance.objective && (
        <>
          <SC.SectionHeading>OBJECTIVES</SC.SectionHeading>
          <SC.DescriptionParagraph>{controlInstance.objective}</SC.DescriptionParagraph>
        </>
      )}

      {controlInstance.type && (
        <>
          <SC.SectionHeading>TYPE</SC.SectionHeading>
          <SC.DescriptionParagraph>{controlInstance.type}</SC.DescriptionParagraph>
        </>
      )}

      {controlInstance.automation && (
        <>
          <SC.SectionHeading>AUTOMATION</SC.SectionHeading>
          <SC.DescriptionParagraph>{controlInstance.automation}</SC.DescriptionParagraph>
        </>
      )}
    </SC.DetailsContainer>
  );
};
